/* tslint:disable */
/* eslint-disable */
/**
 * EVIMO API
 * Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateTriggerConditionRequestDto } from './CreateTriggerConditionRequestDto';
import {
    CreateTriggerConditionRequestDtoFromJSON,
    CreateTriggerConditionRequestDtoFromJSONTyped,
    CreateTriggerConditionRequestDtoToJSON,
    CreateTriggerConditionRequestDtoToJSONTyped,
} from './CreateTriggerConditionRequestDto';

/**
 * 
 * @export
 * @interface UpdateTriggerRequestDto
 */
export interface UpdateTriggerRequestDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateTriggerRequestDto
     */
    basis?: UpdateTriggerRequestDtoBasisEnum;
    /**
     * 1–2 conditions: at most one TIME and one METER. Domain + DB unique(triggerId, conditionType) enforce this.
     * @type {Array<CreateTriggerConditionRequestDto>}
     * @memberof UpdateTriggerRequestDto
     */
    conditions?: Array<CreateTriggerConditionRequestDto>;
}


/**
 * @export
 */
export const UpdateTriggerRequestDtoBasisEnum = {
    Floating: 'FLOATING',
    Fixed: 'FIXED'
} as const;
export type UpdateTriggerRequestDtoBasisEnum = typeof UpdateTriggerRequestDtoBasisEnum[keyof typeof UpdateTriggerRequestDtoBasisEnum];


/**
 * Check if a given object implements the UpdateTriggerRequestDto interface.
 */
export function instanceOfUpdateTriggerRequestDto(value: object): value is UpdateTriggerRequestDto {
    return true;
}

export function UpdateTriggerRequestDtoFromJSON(json: any): UpdateTriggerRequestDto {
    return UpdateTriggerRequestDtoFromJSONTyped(json, false);
}

export function UpdateTriggerRequestDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateTriggerRequestDto {
    if (json == null) {
        return json;
    }
    return {
        
        'basis': json['basis'] == null ? undefined : json['basis'],
        'conditions': json['conditions'] == null ? undefined : ((json['conditions'] as Array<any>).map(CreateTriggerConditionRequestDtoFromJSON)),
    };
}

export function UpdateTriggerRequestDtoToJSON(json: any): UpdateTriggerRequestDto {
    return UpdateTriggerRequestDtoToJSONTyped(json, false);
}

export function UpdateTriggerRequestDtoToJSONTyped(value?: UpdateTriggerRequestDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'basis': value['basis'],
        'conditions': value['conditions'] == null ? undefined : ((value['conditions'] as Array<any>).map(CreateTriggerConditionRequestDtoToJSON)),
    };
}

